import { useEffect } from "react";

import Modal from "~/components/Modal";
import Difficulty from "~/components/Difficulty";
import RecipeRating from "~/components/RecipeRating";
import type { IGetMenuRecipeItem, IRecipesItem } from "~/providers/interfaces";
import { getAmount, getPortions, trans } from "~/utils/trans";
import { parseRecipeParts, getImagePath } from "~/utils/utils";
import { INGREDIENT_REPLACER, PHOTO_REPLACER, DEFAULT_IMAGE_RECIPE } from "~/const";

import "./style.less";
import { useImageExists } from "~/hooks/useImageExists";

interface IRecipesTest {
	recipe: IRecipesItem | IGetMenuRecipeItem | null;
	onClose?: () => void;
	// hodnoceni jen pro cteni (nahled v administraci)
	ratingReadOnly?: boolean;
}

export default function RecipesPreviewModal({
	recipe = null,
	onClose = () => {},
	ratingReadOnly = false,
}: IRecipesTest) {
	const parts = parseRecipeParts(recipe?.process || "");
	const imgSrc = getImagePath(recipe.image_path);
	const imageExists = useImageExists(imgSrc);
	// recept z jidelnicku ma id v id_recipe, v administraci v id
	const recipeId = recipe && "id_recipe" in recipe ? recipe.id_recipe : (recipe as IRecipesItem)?.id;

	useEffect(() => {
		try {
			// Kontrola, zda už reklama nebyla pushnuta, aby se předešlo chybám
			//Vypnutá reklama
			//(window.adsbygoogle = window.adsbygoogle || []).push({});
		} catch (err) {
			//console.error("AdSense error:", err);
		}
	}, []);

	/* eslint-disable  react/no-array-index-key */
	return <Modal onClose={onClose} className="recipePreviewModal">
		<div className="inner-cont">
			<div className="recipe-area">
				<div className="recipePreviewModal__header">
					<h2>{ recipe?.name }</h2>
					{ recipe?.difficulty > 0 && <Difficulty value={recipe.difficulty} /> }
					{ recipeId > 0 && <RecipeRating recipeId={recipeId} readOnly={ratingReadOnly} /> }
				</div>
				{ parts.map((item, ind) => <div key={ind}>
					{ item.type === "expr" && <>
						{ item.value === INGREDIENT_REPLACER && <>
							<h3 className="ingredientsTableHeader">
								{trans("common.ingredients")}
								<strong className="recipePreviewModal__strong">{ getPortions(recipe?.portions || 0) }</strong>
							</h3>
							<table className="ingredientsTable">
								<thead>
									<tr>
										<th colSpan={2}>{trans("shopping.ingredient")}</th>
										<th className="right">{trans("common.quantity")}</th>
									</tr>
								</thead>
								<tbody>
									{recipe?.ingredients.map(ingredient => <tr key={ingredient.id}>
										<td colSpan={2}>
											{ingredient.name}
										</td>
										<td className="right">
											{ getAmount(ingredient) }
										</td>
									</tr>) }
								</tbody>
							</table>
						</> }
						{ item.value === PHOTO_REPLACER && <img className="recipePreviewModal__img" alt={recipe.name} width="320" src={imageExists === "ok" ? imgSrc : DEFAULT_IMAGE_RECIPE} /> }
					</> }
					{ item.type === "text" && <p dangerouslySetInnerHTML={{ __html: item.value }}></p> }
				</div>)}
				{/*Vypnuti reklamy u receptu
				<div className="adsBanner">
					<ins className="adsbygoogle"
						style= {{ display: 'block' }}
						data-ad-client="ca-pub-4612020243596066"
						data-ad-slot="8672278343"
						data-ad-format="auto"
						data-full-width-responsive="true"></ins>
				</div>
				*/}
			</div>
		</div>
	</Modal>;
}
